export const PatientTaskStatus = Object.freeze({
  Scheduled: { value: 0, label: 'Scheduled', textColor: '#FFFFFF', backgroundColor: '#9D97C7' },
  New: { value: 1, label: 'New', textColor: '#FFFFFF', backgroundColor: '#9D97C7' },
  InProgress: { value: 2, label: 'In Progress', textColor: '#FFFFFF', backgroundColor: '#F1BF72' },
  Completed: { value: 3, label: 'Completed', textColor: '#FFFFFF', backgroundColor: '#637768' },
  Canceled: { value: 4, label: 'Canceled', textColor: '#FFFFFF', backgroundColor: '#F01F51B2' },
  UnableToComplete: {
    value: 5,
    label: 'Unable to Complete',
    textColor: '#FFFFFF',
    backgroundColor: '#F01F51B2',
  },
});

export const ActivePatientTaskStatuses = [
  PatientTaskStatus.Scheduled.value,
  PatientTaskStatus.New.value,
  PatientTaskStatus.InProgress.value,
];

// Types
export const ALL_TASK_TYPES = Object.freeze({
  value: '',
  label: 'All Types',
});

export const TaskType = Object.freeze({
  SocialWorkReferral: { value: 1, label: 'Social Work Referral' },
  Administrative: { value: 2, label: 'Administrative' },
  Diabetes: { value: 3, label: 'Diabetes' },
  Compliance: { value: 4, label: 'Compliance' },
  ScheduleVisit: { value: 5, label: 'Schedule Visit' },
  RescheduleVisit: { value: 6, label: 'Reschedule Visit' },
  BGM: { value: 7, label: 'BGM' },
  CGM: { value: 8, label: 'CGM' },
  Engagement: { value: 9, label: 'Engagement' },
  BillingAndInsurance: { value: 10, label: 'Billing And Insurance' },
  CareCoordination: { value: 11, label: 'Care Coordination' },
  StarRatings: { value: 12, label: 'Star Ratings' },
  Cognitive: { value: 13, label: 'Cognitive' },
  Labs: { value: 14, label: 'Labs' },
  GUIDE: { value: 15, label: 'GUIDE' },
  AthenaIntegration: { value: 16, label: 'Athena Integration' },
  CareCoordinationCaregiverOutreach: { value: 17, label: 'Care Coordination Caregiver Outreach' },
  MemberPortal: { value: 18, label: 'Member Portal' },
});

// Reasons
export const ALL_TASK_TYPE_REASONS = Object.freeze({
  value: '',
  label: 'All Reasons',
});

export const TaskReason = Object.freeze({
  NewReferral: { value: 1, label: 'New Referral' },
  NewIssue: { value: 2, label: 'New Issue' },
  NeedsRpmApproval: { value: 3, label: 'Needs Rpm Approval' },
  AccountClosureNeeded: { value: 4, label: 'Account Closure Needed' },
  MFARequest: { value: 5, label: 'MFA Request' },
  CommercialPlanReview: { value: 6, label: 'Commercial Plan Review' },
  HypoglycemicRisk: {
    value: 7,
    label: 'Chart indicates increased risk of hypoglycemic events over the last 30 days',
  },
  BiannualVisit: { value: 8, label: 'Chart indicates that member is due for a bi-annual visit' },
  MFARenewal: { value: 9, label: 'Member’s MFA is about to expire' },
  CGMQualificationVisit: { value: 10, label: 'CGM Qualification Visit' },
  InteractionAdjustment: { value: 11, label: 'Interaction Adjustments' },
  ClinicalFirstVisit: { value: 12, label: 'Clinical First Visit' },
  InitialCoachingCall: { value: 13, label: 'Initial Coaching Call' },
  MonthlyWellnessVisit: { value: 14, label: 'Monthly Wellness Visit' },
  NutritionMedicationAssessment: { value: 15, label: 'Nutrition Medication Assessment' },
  MedicationReconciliation: { value: 16, label: 'Medication Reconciliation' },
  QuarterlyCheckIn: { value: 17, label: 'Quarterly Check-in' },
  ClinicalMeeting: { value: 18, label: 'Clinical Meeting' },
  InsulinPumpTrainingVisit: { value: 19, label: 'Insulin Pump Training Visit' },
  MFADecision: { value: 20, label: 'MFA Decision' },
  BGMDeviceTrainingVisit: { value: 21, label: 'BGM Device Training Visit' },
  CGMDeviceTrainingVisit: { value: 22, label: 'CGM Device Training Visit' },
  FirstReadingOutstanding: { value: 23, label: 'First Reading Outstanding' },
  MemberNeedsSupplies: { value: 24, label: 'Member Needs Supplies' },
  DeliveredToWrongAddress: { value: 25, label: 'Delivered To Wrong Address' },
  SetupNeeded: { value: 26, label: 'Setup Needed' },
  DeviceTroubleshooting: { value: 27, label: 'Device Troubleshooting' },
  QualificationRequested: { value: 28, label: 'Qualification Requested' },
  QuestionAboutOrder: { value: 29, label: 'Question About Order' },
  NoRecentBGMReadings: { value: 30, label: 'No Recent BGM Readings' },
  NoRecentCGMReadings: { value: 31, label: 'No Recent CGM Readings' },
  PhoneNumberNotInService: { value: 32, label: 'Phone Number Not In Service' },
  NoUpcomingScheduledVisits: { value: 33, label: 'No Upcoming Scheduled Visits' },
  FollowUpOnInvoice: { value: 34, label: 'Follow Up On Invoice' },
  BillingQuestion: { value: 35, label: 'Billing Question' },
  SecondaryInsuranceInformationNeeded: {
    value: 36,
    label: 'Secondary Insurance Information Needed',
  },
  InsurancePlanChanged: { value: 37, label: 'Insurance Plan Changed' },
  IneligiblePlan: { value: 38, label: 'Ineligible Plan' },
  PreClosureReachOut: { value: 39, label: 'Pre Closure Reach Out' },
  FaxRecords: { value: 40, label: 'Fax Records' },
  CollectVitals: { value: 41, label: 'Collect Vitals' },
  A1cIncrease: { value: 42, label: 'A1C Increase' },
  CollectA1c: { value: 43, label: 'Collect A1C' },
  CGMReviewNeeded: { value: 44, label: 'CGM Review Needed' },
  NewCoverageAdded: { value: 45, label: 'New Coverage Added' },
  ChangeCoverageDatesOrStatus: { value: 46, label: 'Change Coverage Dates Or Status' },
  CGMOrderRenewal: { value: 47, label: 'CGM Order Renewal' },
  AbnormalHierarchies: { value: 48, label: 'Abnormal Hierarchies' },
  DietaryNutritionalFollowUp: { value: 49, label: 'Dietary and Nutritional Follow-Up' },
  CGMQualificationOpportunity: { value: 50, label: 'CGM Qualification Opportunity' },
  EyeExam: { value: 51, label: 'Eye Exam' },
  FootExam: { value: 52, label: 'Foot Exam' },
  KidneyHealth: { value: 53, label: 'Kidney Health' },
  CognitiveScreening: { value: 54, label: 'Cognitive Screening' },
  NeurologistCall: { value: 55, label: 'Neurologist Call' },
  EligibleForScreening: { value: 56, label: 'Eligible for screening' },
  ScreeningsCompleted: { value: 57, label: 'Screenings Completed' },
  LabToBeOrdered: { value: 58, label: 'Lab to be ordered' },
  LabResultsNormal: { value: 59, label: 'Results - Normal' },
  LabResultsAbnormal: { value: 60, label: 'Results - Abnormal' },
  LabResultsCritical: { value: 61, label: 'Results - Critical' },
  MissingLabResponse: { value: 62, label: 'Missing Lab Response' },
  CognitiveResultsNormal: { value: 63, label: 'Normal Cognitive Result' },
  CognitiveResultsAbnormal: { value: 64, label: 'Abnormal Cognitive Result' },
  CognitiveResultsCritical: { value: 65, label: 'Critical Cognitive Result' },
  GUIDEAssessment: { value: 66, label: 'GUIDE Assessment' },
  GUIDEAlignment: { value: 67, label: 'GUIDE Alignment' },
  CognitiveEvaluation: { value: 68, label: 'Cognitive Evaluation' },
  GUIDEInitialComprehensiveAssessment: {
    value: 69,
    label: 'GUIDE Initial Comprehensive Assessment',
  },
  GUIDEFollowUp: { value: 70, label: 'GUIDE Follow-Up' },
  GUIDETransitionalCareManagement: {
    value: 71,
    label: 'GUIDE Transitional Care Management',
  },
  GUIDEPhoneEncounter: { value: 72, label: 'GUIDE Phone Encounter' },
  NutritionalAppointment: { value: 73, label: 'Nutritional Appointment' },
  NeurologyEvaluation: { value: 74, label: 'In-Person Neurology Evaluation' },
  NeurologyFollowUp: { value: 75, label: 'In-Person Neurology Follow-Up' },
  TelehealthNeurologyEvaluation: { value: 76, label: 'Telehealth Neurology Evaluation' },
  TelehealthNeurologyFollowUp: { value: 77, label: 'Telehealth Neurology Follow-Up' },
  CreatePatientRecordInAthena: { value: 78, label: 'Create Patient Record in Athena' },
  CreateAthenaIntegrationDeeplink: { value: 79, label: 'Create Athena Integration Deeplink' },
  CognitiveAssessmentFlagged: { value: 80, label: 'Cognitive Assessment Flagged' },
  SetupAthenaInsurance: { value: 81, label: 'Setup Athena Insurance' },
  NewMessageReceived: { value: 82, label: 'New Message Received' },
});

export const CREATABLE_TASK_TYPES = [
  TaskType.SocialWorkReferral,
  TaskType.Administrative,
  TaskType.Diabetes,
  TaskType.Compliance,
  TaskType.ScheduleVisit,
  TaskType.RescheduleVisit,
  TaskType.BGM,
  TaskType.CGM,
  TaskType.Engagement,
  TaskType.BillingAndInsurance,
  TaskType.CareCoordination,
  TaskType.CareCoordinationCaregiverOutreach,
  TaskType.StarRatings,
  TaskType.AthenaIntegration,
];

export const CREATABLE_TASK_REASONS = [
  TaskReason.NewReferral,
  TaskReason.NewIssue,
  TaskReason.NeedsRpmApproval,
  TaskReason.AccountClosureNeeded,
  TaskReason.MFARequest,
  TaskReason.CommercialPlanReview,
  TaskReason.HypoglycemicRisk,
  TaskReason.BiannualVisit,
  TaskReason.MFARenewal,
  TaskReason.CGMQualificationVisit,
  TaskReason.InteractionAdjustment,
  TaskReason.ClinicalFirstVisit,
  TaskReason.InitialCoachingCall,
  TaskReason.MonthlyWellnessVisit,
  TaskReason.NutritionMedicationAssessment,
  TaskReason.MedicationReconciliation,
  TaskReason.QuarterlyCheckIn,
  TaskReason.ClinicalMeeting,
  TaskReason.InsulinPumpTrainingVisit,
  TaskReason.MFADecision,
  TaskReason.BGMDeviceTrainingVisit,
  TaskReason.CGMDeviceTrainingVisit,
  TaskReason.FirstReadingOutstanding,
  TaskReason.MemberNeedsSupplies,
  TaskReason.DeliveredToWrongAddress,
  TaskReason.SetupNeeded,
  TaskReason.DeviceTroubleshooting,
  TaskReason.QualificationRequested,
  TaskReason.QuestionAboutOrder,
  TaskReason.NoRecentBGMReadings,
  TaskReason.NoRecentCGMReadings,
  TaskReason.PhoneNumberNotInService,
  TaskReason.NoUpcomingScheduledVisits,
  TaskReason.FollowUpOnInvoice,
  TaskReason.BillingQuestion,
  TaskReason.SecondaryInsuranceInformationNeeded,
  TaskReason.InsurancePlanChanged,
  TaskReason.IneligiblePlan,
  TaskReason.PreClosureReachOut,
  TaskReason.FaxRecords,
  TaskReason.DietaryNutritionalFollowUp,
  TaskReason.CGMOrderRenewal,
  TaskReason.EyeExam,
  TaskReason.FootExam,
  TaskReason.KidneyHealth,
  TaskReason.CognitiveScreening,
  TaskReason.NeurologistCall,
  TaskReason.GUIDEInitialComprehensiveAssessment,
  TaskReason.GUIDEFollowUp,
  TaskReason.GUIDETransitionalCareManagement,
  TaskReason.GUIDEPhoneEncounter,
  TaskReason.NutritionalAppointment,
  TaskReason.NeurologyEvaluation,
  TaskReason.NeurologyFollowUp,
  TaskReason.TelehealthNeurologyEvaluation,
  TaskReason.TelehealthNeurologyFollowUp,
  TaskReason.CreatePatientRecordInAthena,
  TaskReason.CreateAthenaIntegrationDeeplink,
  TaskReason.CognitiveAssessmentFlagged,
  TaskReason.SetupAthenaInsurance,
];

export const TASK_REASON_MAPPING = Object.freeze({
  [TaskType.SocialWorkReferral.value]: [TaskReason.NewReferral.value, TaskReason.NewIssue.value],
  [TaskType.Administrative.value]: [
    TaskReason.NeedsRpmApproval.value,
    TaskReason.AccountClosureNeeded.value,
    TaskReason.MFARequest.value,
    TaskReason.CommercialPlanReview.value,
    TaskReason.MFARenewal.value,
    TaskReason.MFADecision.value,
  ],
  [TaskType.Diabetes.value]: [
    TaskReason.HypoglycemicRisk.value,
    TaskReason.NutritionalAppointment.value,
  ],
  [TaskType.Compliance.value]: [TaskReason.CGMOrderRenewal.value],
  [TaskType.ScheduleVisit.value]: [
    TaskReason.BiannualVisit.value,
    TaskReason.CGMQualificationVisit.value,
    TaskReason.ClinicalFirstVisit.value,
    TaskReason.InitialCoachingCall.value,
    TaskReason.MonthlyWellnessVisit.value,
    TaskReason.NutritionMedicationAssessment.value,
    TaskReason.MedicationReconciliation.value,
    TaskReason.QuarterlyCheckIn.value,
    TaskReason.ClinicalMeeting.value,
    TaskReason.InsulinPumpTrainingVisit.value,
    TaskReason.BGMDeviceTrainingVisit.value,
    TaskReason.CGMDeviceTrainingVisit.value,
    TaskReason.DietaryNutritionalFollowUp.value,
    TaskReason.CognitiveScreening.value,
    TaskReason.NeurologistCall.value,
    TaskReason.GUIDEInitialComprehensiveAssessment.value,
    TaskReason.GUIDEFollowUp.value,
    TaskReason.GUIDETransitionalCareManagement.value,
    TaskReason.GUIDEPhoneEncounter.value,
    TaskReason.NeurologyEvaluation.value,
    TaskReason.NeurologyFollowUp.value,
    TaskReason.TelehealthNeurologyEvaluation.value,
    TaskReason.TelehealthNeurologyFollowUp.value,
  ],
  [TaskType.RescheduleVisit.value]: [
    TaskReason.BiannualVisit.value,
    TaskReason.CGMQualificationVisit.value,
    TaskReason.ClinicalFirstVisit.value,
    TaskReason.InitialCoachingCall.value,
    TaskReason.MonthlyWellnessVisit.value,
    TaskReason.NutritionMedicationAssessment.value,
    TaskReason.MedicationReconciliation.value,
    TaskReason.QuarterlyCheckIn.value,
    TaskReason.ClinicalMeeting.value,
    TaskReason.InsulinPumpTrainingVisit.value,
    TaskReason.BGMDeviceTrainingVisit.value,
    TaskReason.CGMDeviceTrainingVisit.value,
    TaskReason.DietaryNutritionalFollowUp.value,
    TaskReason.CognitiveScreening.value,
    TaskReason.NeurologistCall.value,
    TaskReason.GUIDEInitialComprehensiveAssessment.value,
    TaskReason.GUIDEFollowUp.value,
    TaskReason.GUIDETransitionalCareManagement.value,
    TaskReason.GUIDEPhoneEncounter.value,
    TaskReason.NeurologyEvaluation.value,
    TaskReason.NeurologyFollowUp.value,
    TaskReason.TelehealthNeurologyEvaluation.value,
    TaskReason.TelehealthNeurologyFollowUp.value,
  ],
  [TaskType.BGM.value]: [
    TaskReason.FirstReadingOutstanding.value,
    TaskReason.DeviceTroubleshooting.value,
    TaskReason.MemberNeedsSupplies.value,
    TaskReason.DeliveredToWrongAddress.value,
  ],
  [TaskType.CGM.value]: [
    TaskReason.FirstReadingOutstanding.value,
    TaskReason.SetupNeeded.value,
    TaskReason.DeviceTroubleshooting.value,
    TaskReason.QualificationRequested.value,
    TaskReason.QuestionAboutOrder.value,
  ],
  [TaskType.Engagement.value]: [
    TaskReason.NoRecentBGMReadings.value,
    TaskReason.NoRecentCGMReadings.value,
    TaskReason.PhoneNumberNotInService.value,
    TaskReason.NoUpcomingScheduledVisits.value,
    TaskReason.PreClosureReachOut.value,
  ],
  [TaskType.BillingAndInsurance.value]: [
    TaskReason.MFADecision.value,
    TaskReason.FollowUpOnInvoice.value,
    TaskReason.BillingQuestion.value,
    TaskReason.SecondaryInsuranceInformationNeeded.value,
    TaskReason.InsurancePlanChanged.value,
    TaskReason.IneligiblePlan.value,
    TaskReason.SetupAthenaInsurance.value,
  ],
  [TaskType.CareCoordination.value]: [TaskReason.FaxRecords.value],
  [TaskType.CareCoordinationCaregiverOutreach.value]: [TaskReason.CognitiveAssessmentFlagged.value],
  [TaskType.MemberPortal.value]: [TaskReason.NewMessageReceived.value],
  [TaskType.StarRatings.value]: [
    TaskReason.EyeExam.value,
    TaskReason.FootExam.value,
    TaskReason.KidneyHealth.value,
  ],
  [TaskType.AthenaIntegration.value]: [
    TaskReason.CreatePatientRecordInAthena.value,
    TaskReason.CreateAthenaIntegrationDeeplink.value,
  ],
});

export const CURIE_AI_REASONS = [TaskReason.CGMOrderRenewal.value];
